import * as actionTypes from '../actionTypes/adminTypes';

export function showBlockingLoader(payload) {
  return {
    type: actionTypes.BLOCKING_LOADER,
    payload
  };
}

export const updateEntities = payload => ({
  type: actionTypes.UPDATE_ENTITIES,
  payload
});

export const appInitError = payload => ({
  type: actionTypes.APP_INIT_ERROR,
  payload
});